// extracted by mini-css-extract-plugin
export default {"order_page":"OrderList_order_page__+T56n","order_content":"OrderList_order_content__jCiZd"};